import {
  type AxiosInstance,
  type AxiosResponse,
  HttpStatusCode,
  isAxiosError,
} from "axios";
import { SendToTrackingService } from "@/api/handlers/errors";
import { baseURL } from "@/configs";

interface IRequests {
  id: number;
  filename: string;
}

/**
 * 物件概要書をダウンロードするAPIを叩いてファイルとしてダウンロードする
 * @param {AxiosInstance} apiClient
 * @param {IRequests} requests
 */
export const GetPropertySummaryAsFileAPI = async (
  apiClient: AxiosInstance,
  requests: IRequests
): Promise<void> => {
  const urlWithParams = `${baseURL}/property-summary/${requests.id}/file`;

  try {
    const response = await apiClient.get<unknown, AxiosResponse<Blob>>(
      urlWithParams,
      {
        responseType: "blob",
      }
    );

    // ダウンロードが現時点で不可なので新規ウィンドウでHTMLとして開く
    const blob = new Blob([response.data], { type: "text/html" });
    const url = URL.createObjectURL(blob);
    window.open(url, "_blank");

    // ダウンロードの場合は下記コードを使う
    // const filename = getAttachedFileNameFromHeader(response, requests.filename);
    // fileDownload(response.data, filename);
  } catch (error) {
    if (
      isAxiosError<AxiosResponse>(error) &&
      (error.response?.status ?? HttpStatusCode.InternalServerError) >=
        HttpStatusCode.InternalServerError
    ) {
      SendToTrackingService(error);
    }
    throw error;
  }
};
